import { api } from "./api";
import type {
  AppNotification,
  PaginatedResponse,
  UserDeviceCreate,
  UserDeviceResponse,
} from "types/domain";

export const notificationService = {
  getMyNotifications(skip = 0, limit = 50, unreadOnly = false) {
    const params = new URLSearchParams({
      skip: String(skip),
      limit: String(limit),
      unread_only: String(unreadOnly),
    });
    return api.get<PaginatedResponse<AppNotification>>(
      `/users/me/notifications?${params}`
    );
  },

  getUnreadCount() {
    return api.get<{ unread_count: number }>(
      "/users/me/notifications/unread-count"
    );
  },

  markAsRead(id: string) {
    return api.patch<AppNotification>(
      `/users/me/notifications/${id}/read`,
      {}
    );
  },

  markAllAsRead() {
    return api.post<{ marked_count: number }>(
      "/users/me/notifications/mark-all-read",
      {}
    );
  },

  registerDevice(data: UserDeviceCreate) {
    return api.post<UserDeviceResponse>("/users/me/devices", data);
  },

  unregisterDevice(fcmToken: string) {
    return api.delete<{ message: string }>(
      `/users/me/devices/${encodeURIComponent(fcmToken)}`
    );
  },

  // Manager endpoints
  sendToUsers(
    userIds: string[],
    title: string,
    message: string,
    sessionId?: string,
    scheduledAt?: string
  ) {
    return api.post<{ sent_count: number; scheduled?: boolean }>("/notifications/send", {
      user_ids: userIds,
      title,
      message,
      session_id: sessionId,
      scheduled_at: scheduledAt || undefined,
    });
  },

  notifySession(sessionId: string, title?: string, message?: string, targetRole?: string, scheduledAt?: string) {
    return api.post<{ sent_count: number; scheduled?: boolean }>(
      `/sessions/${sessionId}/notify`,
      { title, message, target_role: targetRole || undefined, scheduled_at: scheduledAt || undefined }
    );
  },
};
